export const useParametersService = createGlobalState(() => {
	const { t, locale } = useI18n()

	// Pre-compute all 3 bag text variants — only 3 possible outcomes per locale
	const bagTexts = computed(() => ({
		one: {
			bag: t('components.car_parameters.bag.one'),
			small: t('components.car_parameters.small.one'),
			big: t('components.car_parameters.big.one'),
		},
		few: {
			bag: t('components.car_parameters.bag.two'),
			small: t('components.car_parameters.small.two'),
			big: t('components.car_parameters.big.two'),
		},
		many: {
			bag: t('components.car_parameters.bag.more'),
			small: t('components.car_parameters.small.more'),
			big: t('components.car_parameters.big.more'),
		},
	}))

	const getBagTexts = (count: number) => {
		if (count === 1) return bagTexts.value.one
		if (count > 1 && count < 5) return bagTexts.value.few
		return bagTexts.value.many
	}

	const bagsParamText = (bigBag?: IProductParameterModel, smallBag?: IProductParameterModel): string => {
		if (bigBag && smallBag) {
			const bigText = getBagTexts(Number(bigBag.value))
			const smallText = getBagTexts(Number(smallBag.value))
			return `${bigBag.value} ${bigText.big} ${bigText.bag}, ${smallBag.value} ${smallText.small}`
		} else if (bigBag) {
			const bigText = getBagTexts(Number(bigBag.value))
			return `${bigBag.value} ${bigText.big} ${bigText.bag}`
		} else if (smallBag) {
			const smallText = getBagTexts(Number(smallBag.value))
			return `${smallBag.value} ${smallText.small} ${smallText.bag}`
		}
		return ''
	}

	const filteredParametersByBags = (parameters?: IProductParameterModel[]) => {
		if (!parameters) return []

		const bigBagsParameter = parameters.find((p) => p.name === 'Big Bags Capacity')
		const smallBagsParameter = parameters.find((p) => p.name === 'Small Bags Capacity')

		if (!(bigBagsParameter || smallBagsParameter)) {
			return parameters
		}

		const customBagsParameter = {
			name: 'Trunk Capacity',
			value: bagsParamText(bigBagsParameter, smallBagsParameter),
		} as IProductParameterModel

		const filteredParameters = parameters.filter((p) => p.name !== 'Big Bags Capacity' && p.name !== 'Small Bags Capacity')

		return [...filteredParameters, customBagsParameter]
	}

	return { filteredParametersByBags, locale }
})
